import React, { useEffect, useState, useMemo } from "react";
import { useTable, useRowSelect, usePagination, useSortBy } from "react-table";
import "./styleTable.scss";
import BTable from "react-bootstrap/Table";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { openDetailGrille } from "../../redux/actions/design";
import { PDFExport } from "@progress/kendo-react-pdf";
import DetailGrille from "./DetailGrille";
import iconAction from "../../assets/images/icon-action.png";
import iconFile from "../../assets/images/icon-file-active.svg";
import iconBlocked from "../../assets/images/BlockIcon.png";
import iconPdf from "../../assets/images/pdf-non-active.png";
import iconDuplicate from "../../assets/images/icon-dupliquer.png";
import iconBlockedActive from "../../assets/images/noun-blocked-active.png";
import iconPdfActive from "../../assets/images/noun-pdf-active.png";
import iconDuplicateActive from "../../assets/images/noun-duplicate-active.png";
import iconCalendar from "../../assets/images/icon-calendar.png";
import RingLoaderShared from "../../shared/RingLoader/RingLoader";
import {
  getMesGridsDesactivee,
  getMesGrilles,
  getOneGrilles,
  deactivateGrid,
  allGrillesDesactiver,
  getGrillesByTenant,
} from "../../redux/actions/grille";
import { useHistory } from "react-router-dom";
import Alert from "../../components/Alert/Alert";
import GoToEvalIcon from "../../assets/images/icon-goToEval.svg";
import GoToEvalIconActive from "../../assets/images/icon-goToEval-active.svg";
import { getPermissionsByuser } from "../../redux/actions/permissions";
import { Avatar } from "@mui/material";
const TableGrille = (props) => {
  const { isOpen, status1 } = useSelector((state) => state.design);

  const hisotry = useHistory();

  const [count, setCount] = useState(0);
  const { datagrilles, datagrille, datagrillesdesactiver, datagrillesUsers } =
    useSelector((state) => state.grille);
  const { message, status } = useSelector((state) => state.message);
  const [display, setDisplay] = useState("none");
  const [displayAlertDownload, setDisplayAlertDownload] = useState(false);
  const { dataPermissionsByuser } = useSelector((state) => state.permissions);
  const [haspermission, setHaspermission] = useState(props.haspermission);
  const [evaluer, setEvaluer] = useState(props.evaluer);
  const user = JSON.parse(localStorage.getItem("user"));
  const user_auth0 = JSON.parse(localStorage.getItem("user_auth0"));

  const pdfExportComponent = React.useRef(null);
  const [showspinner, setShowspinner] = useState(true);

  const [pageI, setPageI] = useState(0);

  var selectedId = null;
  const dispatch = useDispatch();
  const [errorMessageEdit, setErrorMessageEdit] = useState(null);

  useEffect(() => {
    setEvaluer(props.evaluer);
    setHaspermission(props.haspermission);
    setCount(0);
  }, [dispatch, getPermissionsByuser, haspermission, evaluer]);

  useEffect(() => {
    setShowspinner(true);
    fetchdata(0, pageSize);
  }, [dispatch, status1]);

  const fetchdata = (pageI, size) => {
    if (!status1) {
      user_auth0["http://role.tn/roles"][0] === "AGENT"
        ? dispatch(getMesGrilles(pageI, size))
            .then(() => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            })
        : dispatch(getGrillesByTenant(pageI, size))
            .then(() => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            });
      props.setChecked(false);
    } else {
      user_auth0["http://role.tn/roles"][0] === "AGENT"
        ? dispatch(getMesGridsDesactivee(pageI, size))
            .then(() => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            })
        : dispatch(allGrillesDesactiver(pageI, size))
            .then(() => {
              setShowspinner(false);
            })
            .catch((err) => {
              console.log("err", err);
            });

      props.setChecked(true);
    }
  };

  const deactivate = () => {
    dispatch(deactivateGrid(selectedId))
      .then(() => {
        setTimeout(() => {
          fetchdata(0, 10);
          setDisplay("none");
        }, 3000);
        setDisplay("block");
        document.getElementById("tooltip-bottom-action").style.display = "none";
      })
      .catch(() => {
        setDisplay("block");
      });
    setTimeout(() => {
      setDisplay("none");
    }, 3000);
  };

  const dupliquer = () => {
    dispatch(getOneGrilles(selectedId));
    hisotry.push(`/dup-grille?id=${selectedId}`);
  };

  const handelchangeExportdetailspdf = () => {
    if (pdfExportComponent.current) {
      pdfExportComponent.current.save();
      setDisplay("block");
      setDisplayAlertDownload(true);
      document.getElementById("tooltip-bottom-action").style.display = "none";
    }
    setTimeout(() => {
      setDisplay("none");
      setDisplayAlertDownload(false);
    }, 3000);
  };
  const onDisplay = (display) => {
    setDisplay(display);
  };

  const popover = (haspermission, evaluer, status) => (
    <Tooltip
      id="tooltip-bottom-action"
      style={{ opacity: 1, maxWidth: "300px" }}
    >
      <div className="row">
        {
          <div className="col align-it">
            <OverlayTrigger
              key="bottom"
              style={{ border: 0 }}
              placement="bottom"
              overlay={
                <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                  dupliquer{" "}
                </Tooltip>
              }
            >
              <div
                id="cercle-tooltip-action-disabled"
                style={{ cursor: haspermission ? "pointer" : "not-allowed" }}
              >
                <img
                  alt=""
                  src={iconDuplicate}
                  onMouseOver={(e) =>
                    (e.currentTarget.src = haspermission
                      ? iconDuplicateActive
                      : iconDuplicate)
                  }
                  onMouseOut={(e) => (e.currentTarget.src = iconDuplicate)}
                  width="22"
                  height="22"
                  onClick={haspermission ? dupliquer : null}
                />
              </div>
            </OverlayTrigger>
          </div>
        }
        <div className="col align-it">
          <OverlayTrigger
            key="bottom"
            style={{ border: 0 }}
            placement="bottom"
            overlay={
              <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                enregistrer PDF{" "}
              </Tooltip>
            }
          >
            <div id="cercle-tooltip-action">
              <img
                alt=""
                src={iconPdf}
                onMouseOver={(e) => (e.currentTarget.src = iconPdfActive)}
                onMouseOut={(e) => (e.currentTarget.src = iconPdf)}
                width="22"
                height="22"
                onClick={() => handelchangeExportdetailspdf()}
              />
            </div>
          </OverlayTrigger>
        </div>
        {
          <div
            className="col align-it"
            onClick={() => (haspermission ? deactivate() : null)}
          >
            <OverlayTrigger
              key="bottom"
              style={{ border: 0 }}
              placement="bottom"
              overlay={
                <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                  activer / désactiver{" "}
                </Tooltip>
              }
            >
              <div
                id="cercle-tooltip-action"
                style={{ cursor: haspermission ? "pointer" : "not-allowed" }}
              >
                <img
                  alt=""
                  src={iconBlocked}
                  onMouseOver={(e) =>
                    (e.currentTarget.src = haspermission
                      ? iconBlockedActive
                      : iconBlocked)
                  }
                  onMouseOut={(e) => (e.currentTarget.src = iconBlocked)}
                  width="20"
                  height="20"
                />
              </div>
            </OverlayTrigger>
          </div>
        }
        {
          <div className="col align-it">
            <OverlayTrigger
              key="bottom"
              style={{ border: 0 }}
              placement="bottom"
              overlay={
                evaluer && status ? (
                  <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                    évaluer{" "}
                  </Tooltip>
                ) : (
                  <Tooltip data-color="#5800e2" id={`tooltip-bottom1`}>
                    grille désactiver{" "}
                  </Tooltip>
                )
              }
            >
              <div
                className="align-it"
                style={{
                  cursor: evaluer && status ? "pointer" : "not-allowed",
                }}
              >
                <img
                  style={{
                    width: "22px !important",
                    height: "22px !important",
                    cursor: evaluer && status ? "pointer" : "not-allowed",
                  }}
                  id="cercle-tooltip-action-disabled"
                  alt=""
                  src={GoToEvalIcon}
                  onMouseOver={(e) =>
                    (e.currentTarget.src =
                      evaluer && status ? GoToEvalIconActive : GoToEvalIcon)
                  }
                  onMouseOut={(e) => (e.currentTarget.src = GoToEvalIcon)}
                  onClick={() => {
                    console.log("(evaluer && status)", evaluer && status);

                    if (evaluer && status) {
                      toAddEval(selectedId);
                      dispatch(getOneGrilles(selectedId));
                    }
                  }}
                />
              </div>
            </OverlayTrigger>
          </div>
        }
      </div>
    </Tooltip>
  );

  const toAddEval = props.toAddEval;

  function format(inputDate) {
    let date, month, year;

    date = inputDate.getDate();
    month = inputDate.getMonth() + 1;
    year = inputDate.getFullYear();

    date = date.toString().padStart(2, "0");

    month = month.toString().padStart(2, "0");

    return `${date}/${month}/${year}`;
  }

  const columns = React.useMemo(
    () => [
      {
        Header: "Identifiant",
        accessor: "id",
        Cell: (props) => {
          return (
            <div>
              <span
                className="badge-style-qm"
                pill
                style={{ fontWeight: "Gilroy-Regular" }}
              >
                {props?.value}
              </span>
            </div>
          );
        },
      },
      {
        Header: "Nom",
        accessor: "name",
        Cell: (props) => {
          return (
            <div className="evaluator" style={{ gap: 10 }}>
              <div className="evaluator-spans">
                <span style={{ color: "#000" }}>{props?.value}</span>
              </div>
            </div>
          );
        },
      },

      {
        Header: "Dates",
        accessor: "date",
        id: "date",
        Cell: (props) => {
          let isCreate =
            Date.parse(props?.cell?.row?.original?.createdAt) ===
            Date.parse(props?.cell?.row?.original?.updatedAt);

          return (
            <div style={{ fontSize: 12 }}>
              <div className="flex-box">
                <span style={{ fontSize: 16, fontWeight: "Gilroy-Regular" }}>
                  {isCreate
                    ? `Créée par: ${
                        props.cell.row.original.User.firstName +
                        " " +
                        props.cell.row.original.User.lastName
                      }`
                    : `Modifié par: ${
                        props.cell.row.original.User.firstName +
                        " " +
                        props.cell.row.original.User.lastName
                      }`}
                </span>
                <Avatar
                  alt={props.cell.row.original.User.firstName}
                  sx={{ bgcolor: "#5800E2", width: "30px", height: "30px" }}
                  variant="rounded"
                  className="borderedImg"
                >
                  {props.cell.row.original.User.firstName
                    .charAt(0)
                    .toUpperCase() +
                    props.cell.row.original.User.lastName
                      .charAt(0)
                      .toUpperCase()}
                </Avatar>
                <span
                  style={{
                    fontSize: 14,
                    fontWeight: "Gilroy-Medium",
                    textTransform: "capitalize",
                  }}
                ></span>
              </div>
              <div style={{ color: "#B7B7B7" }}>
                <img width={14} src={iconCalendar} />{" "}
                <span style={{ fontSize: 12 }}>
                  {isCreate
                    ? format(new Date(props?.cell?.row?.original?.createdAt))
                    : format(new Date(props?.cell?.row?.original?.updatedAt))}
                </span>
              </div>
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "action",
        Cell: (props) => {
          return (
            <div style={{ display: "flex", gap: "10px" }}>
              <img
                height={40}
                style={{ cursor: "pointer" }}
                src={iconFile}
                onClick={() => {
                  dispatch(getOneGrilles(props?.data[props?.row?.id]?.id));
                  dispatch(openDetailGrille(true));
                }}
              />
              <OverlayTrigger
                trigger="click"
                placement="bottom-end"
                rootClose
                overlay={popover(
                  haspermission,
                  evaluer,
                  props?.data[props?.row?.id].status
                )}
              >
                <img
                  height={40}
                  style={{ cursor: "pointer" }}
                  src={iconAction}
                  onClick={() => {
                    selectedId = props?.data[props?.row?.id]?.id;

                    dispatch(getOneGrilles(props?.data[props?.row?.id]?.id));
                  }}
                />
              </OverlayTrigger>
            </div>
          );
        },
      },
    ],
    []
  );

  const getVisiblePages = (page, total) => {
    if (total < 7) {
      return filterPages([1, 2, 3, 4, 5, 6], total);
    } else {
      if (page % 5 >= 0 && page > 4 && page + 2 < total) {
        return [1, page - 1, page, page + 1, total];
      } else if (page % 5 >= 0 && page > 4 && page + 2 >= total) {
        return [1, total - 3, total - 2, total - 1, total];
      } else {
        return [1, 2, 3, 4, 5, total];
      }
    }
  };

  const filterPages = (visiblePages, totalPages) => {
    return visiblePages.filter((page) => page <= totalPages);
  };

  const data = useMemo(() => {
    return datagrilles?.grids ?? [];
  }, [datagrilles?.grids]);
  const tableInstance = useTable(
    {
      columns,
      data,
      initialState: { pageIndex: 0, pageSize: 10 },
    },
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
      hooks.visibleColumns.push((columns) => [
        // Let's make a column for selection
        {
          id: "selection",
          // The header can use the table's getToggleAllRowsSelectedProps method
          // to render a checkbox
          Header: ({ getToggleAllRowsSelectedProps }) => (
            <div>
              <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
            </div>
          ),
          // The cell can use the individual row's getToggleRowSelectedProps method
          // to the render a checkbox
          Cell: ({ row }) => (
            // to get ID of row
            <div>
              <IndeterminateCheckbox
                {...row.getToggleRowSelectedProps()}
                row={row}
              />
            </div>
          ),
        },
        ...columns,
      ]);
    }
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,

    // The rest of these things are super handy, too ;)
    canPreviousPage,
    canNextPage,
    pageOptions,
    pageCount,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    selectedFlatRows,
    state: { pageIndex, pageSize, selectedRowIds },
  } = tableInstance;

  const IndeterminateCheckbox = React.forwardRef(
    ({ indeterminate, ...rest }, ref) => {
      const defaultRef = React.useRef();
      const resolvedRef = ref || defaultRef;

      React.useEffect(() => {
        resolvedRef.current.indeterminate = indeterminate;
      }, [resolvedRef, indeterminate, selectedRowIds, count]);
      return (
        <div style={{ marginLeft: "15px" }}>
          <label className="container-checkbox">
            <input type="checkbox" ref={resolvedRef} {...rest} />
            <span className="checkmark"></span>
          </label>
        </div>
      );
    }
  );
  return (
    <div
      className={clsx({
        "responsive-table-dashboard table-resp": !isOpen,
        ["responsive-table-full table-full"]: isOpen,
        table: true,
      })}
    >
      {datagrilles && datagrilles?.totalItems === 0 ? (
        <div className="container-add-groupe-critere">
          <span className="add-grid_btn-title">Aucune grille créée</span>
        </div>
      ) : !showspinner ? (
        <>
          <BTable
            striped
            bordered
            hover
            size="sm"
            {...getTableProps()}
            id="borderless-cell"
          >
            <thead>
              {headerGroups.map((headerGroup, index) => (
                <tr {...headerGroup.getHeaderGroupProps()} key={index}>
                  {headerGroup.headers.map((column, i) => (
                    <th {...column.getHeaderProps()} key={i}>
                      <span {...column.getSortByToggleProps()}>
                        {column.render("Header")}
                        {column.isSorted
                          ? column.isSortedDesc
                            ? "↑"
                            : "↓"
                          : ""}
                      </span>
                    </th>
                  ))}
                </tr>
              ))}
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                page.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()} key={index}>
                      {
                        // Loop over the rows cells
                        row.cells &&
                          row.cells.map((cell, i) => {
                            // Apply the cell props
                            return (
                              <td {...cell.getCellProps()} key={i}>
                                {
                                  // Render the cell contents
                                  cell.render("Cell")
                                }
                              </td>
                            );
                          })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </BTable>

          <div className="pagnation">
            <div className="buttonP">
              <button
                className={clsx({
                  "pagination-chevron-disabled": !(
                    datagrilles?.currentPage > 0
                  ),
                  ["pagination-chevron"]: datagrilles?.currentPage > 0,
                })}
                onClick={() => {
                  setPageI(pageI - 1);
                  fetchdata(pageI - 1, pageSize);
                }}
                disabled={!(datagrilles?.currentPage > 0)}
              >
                <i className="fa fa-chevron-left"></i>
              </button>
            </div>
            {getVisiblePages(
              datagrilles?.currentPage,
              datagrilles?.totalPages
            ).map((page, index, array) => {
              return (
                <button
                  className={clsx({
                    activeP: datagrilles?.currentPage + 1 === page,
                    ["btnP"]: true,
                  })}
                  onClick={() => {
                    setPageI(page - 1);
                    fetchdata(page - 1, pageSize);
                  }}
                  key={page}
                >
                  {page}
                </button>
              );
            })}
            <div className="buttonP">
              <button
                className={clsx({
                  "pagination-chevron-disabled": !(
                    datagrilles?.currentPage + 1 <
                    datagrilles?.totalPages
                  ),
                  ["pagination-chevron"]:
                    datagrilles?.currentPage + 1 < datagrilles?.totalPages,
                })}
                onClick={() => {
                  setPageI(pageI + 1);
                  fetchdata(pageI + 1, pageSize);
                }}
                disabled={
                  datagrilles?.currentPage + 1 === datagrilles?.totalPages
                }
              >
                <i className="fa fa-chevron-right"></i>
              </button>
            </div>
            <select
              className="select-pagination"
              value={pageSize}
              onChange={(e) => {
                setPageSize(Number(e.target.value));
                setPageI(0);
                fetchdata(0, Number(e.target.value));
                getVisiblePages(0, datagrilles?.totalPages);
              }}
            >
              {[5, 10, 15].map((pageSize, k) => (
                <option
                  style={{ textAlignLast: "center" }}
                  key={pageSize}
                  value={pageSize}
                >
                  {pageSize}
                </option>
              ))}
            </select>
          </div>
          {message && status === "error" && (
            <Alert
              message={message}
              status={"danger"}
              display={display}
              onDisplay={onDisplay}
            />
          )}
          {displayAlertDownload && (
            <Alert
              message={"Grille téléchargé avec succès"}
              status={"success"}
              display={display}
              onDisplay={onDisplay}
            />
          )}
          {errorMessageEdit ? (
            <Alert
              message={errorMessageEdit}
              status={"warning"}
              display={display}
              onDisplay={onDisplay}
            />
          ) : null}
          <div
            style={{
              position: "absolute",
              left: "-1000px",
              top: 0,
            }}
          >
            <PDFExport
              paperSize={"A4"}
              fileName={`ROUNDESK_${datagrille?.grid?.name}.pdf`}
              scale={0.7}
              margin="0cm"
              title=""
              subject=""
              keywords=""
              ref={pdfExportComponent}
              forcePageBreak=".chapter"
            >
              <div
                style={{
                  height: "800vh",
                  width: "100%",
                  padding: "none",

                  margin: "auto",
                  overflowX: "hidden",
                  overflowY: "hidden",
                }}
              >
                <DetailGrille elmineDivision={true} />
              </div>
            </PDFExport>
          </div>
        </>
      ) : (
        <RingLoaderShared />
      )}
    </div>
  );
};

export default TableGrille;
